<section>
  <div class="container">
    <div class="row pt-4">
      <div class="col-md-12">
        <h1>Report your injury or illness</h1>
      </div>
    </div>
  </div>
</section>
<section class="">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 class="">Getting started</h2>
      </div>
    </div>
  </div>
</section>

<section>
  <div class="container py-3">
    <div class="row">
      <div class="col-lg-8">
        <blockquote class="blockquote-border-yellow">
          <h3 class="pt-0">
            Did you experience a catastrophic injury, resulting in a long stay in the hospital or
            home care?
          </h3>
          <div>
            If so, please call our Teleclaim team at <a href="#">604.231.8888</a> (or toll-free at
            <a href="#">1.888.967.5377</a>) so we can get you specialized support. Examples of
            catastrophic injuries include a loss of a limb, multiple bone fractures requiring
            surgery, severe burns, and spinal cord injuries.
          </div>
        </blockquote>
      </div>
    </div>
  </div>
</section>

<section class="fadein">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <!-- OPTION 1 -->
        <div id="option-physical" class="option1 content-item">
          <div class="pb-3 pt-3">
            <div class="pb-0 mb-0">
              <b
                >Did your injury or condition occur from a single incident or shift, or did it
                develop over time?</b
              >
            </div>
            <div class="row fadein">
              <div class="col-lg-4 col-md-6">
                <a id="btn-physicalx" class="cardlink" routerLink="/eligibilityQuizInstructions">
                  <div class="infocard bg-white my-2">
                    <h3 class="text-dark pt-0">Single incident</h3>
                    <div>
                      This includes injuries from one specific event, or work activities over the
                      course of a single shift.
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-lg-4 col-md-6">
                <a id="btn-physicalx" class="cardlink" routerLink="/eligibilityQuizChannels">
                  <div class="infocard bg-white my-2">
                    <h3 class="text-dark pt-0">Over time</h3>
                    <div>
                      Injuries that develop over time can take days, weeks, months, or years to
                      manifest
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section id="buttons-overtime">
  <div class="container">
    <div class="row">
      <div class="col">
        <!--actions -->
        <div class="py-3">
          <a class="btn-outline-blue btn-md btn mr-2 mb-2" [routerLink]="['/eligibilityQuizInjury']"
            >Back</a
          >
        </div>
      </div>
    </div>
  </div>
</section>
<section class="">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <hr />
        <div>
          <strong
            >Have a question about reporting your injury? Please call our Teleclaim team at
            <a href="tel:6042318888">604.231.8888</a> (or toll-free at
            <a href="tel:18889675377">1.888.967.5377</a>).</strong
          >
        </div>
      </div>
    </div>
  </div>
</section>
